import { Box, Inline, Text } from 'braid-design-system';
import React from 'react';

import { SearchCriteriaOpportunityType } from 'src/generated/graphql';

interface OpportunityTypeProps {
  opportunityTypes: SearchCriteriaOpportunityType[] | null;
}

export const OpportunityType = ({ opportunityTypes }: OpportunityTypeProps) => {
  const opportunities = opportunityTypes?.map((type) => {
    switch (type) {
      case SearchCriteriaOpportunityType.FranchiseNew: {
        return 'Franchise New';
      }
      case SearchCriteriaOpportunityType.FranchiseResale: {
        return 'Franchise Resale';
      }
      case SearchCriteriaOpportunityType.LicenceDistribution: {
        return 'Licence/Distribution';
      }
      default: {
        return 'Businesses';
      }
    }
  });

  let displayText = 'Businesses and Franchises';

  if (opportunities && opportunities.length === 1) {
    displayText = opportunities.toString();
  }

  if (opportunities && opportunities.length === 2) {
    if (opportunities.indexOf('Businesses') > -1) {
      displayText = opportunities
        .sort((a, b) => (a && b ? a.localeCompare(b) : 0))
        .join(' and ');
    } else {
      displayText = 'Franchises';
    }
  }

  if (opportunities && opportunities.length === 3) {
    if (opportunities.indexOf('Businesses') > -1) {
      displayText = 'Businesses and Franchises';
    } else {
      displayText = 'Franchises';
    }
  }

  return (
    <Inline space="xsmall">
      <Text weight="strong">Opportunity Type:</Text>
      <Box data-testid="profile-saved-searches-listing-type-display-text">
        <Text>{displayText}</Text>
      </Box>
    </Inline>
  );
};
